import type EntryPoint from '../store/schema/EntryPoint';
/**
 * Util to get link with entry point.
 */
export default function getLinkWithEntryPoint(urlLink: string, entryPoint?: EntryPoint): string {
    let newUrlLink = urlLink;
    if (entryPoint) {
        let appendEntryPoint = '';
        switch (entryPoint) {
            case 1:
                appendEntryPoint = '&ep=mlink';
                break;
            case 2:
                appendEntryPoint = '&ep=mcard';
                break;
            case 3:
                appendEntryPoint = '&ep=plink';
                break;
            case 4:
                appendEntryPoint = '&ep=pcard';
                break;
            case 5:
                appendEntryPoint = '&ep=email';
                break;
            case 6:
                appendEntryPoint = '&ep=bwmCollabEmail';
                break;
            case 7:
                appendEntryPoint = '&ep=bwmEmailSignature';
                break;
            case 8:
                appendEntryPoint = '&ep=mLinkFromTile';
                break;
            case 9:
                appendEntryPoint = '&ep=mCardFromTile';
                break;
            case 10:
                appendEntryPoint = '&ep=mSingleUseLinkFromTile';
                break;
            case 11:
                appendEntryPoint = '&ep=mSingleUseCardFromTile';
                break;
        }
        newUrlLink = newUrlLink + appendEntryPoint;
    }
    return newUrlLink;
}
